<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span *ngIf="$.row && $.adata.fetch_key && $.adata.type=='email'">{{emailStatus[$.row[$.adata.fetch_key]]}}</span>
<span *ngIf="$.row && $.adata.fetch_key && $.adata.type=='sms'">{{smsTransactionLogStatus[$.row[$.adata.fetch_key]]}}</span>
<span *ngIf="$.row && $.adata.fetch_key && $.adata.type=='whatsapp'">{{whatsappMessageTransactionLogStatus[$.row[$.adata.fetch_key]]}}</span>

</ng-container>
